import { map as rxjsmap } from 'rxjs';


import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { BaseServices } from './../../kuba.services';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class EmployeeContactServices {
    item: Object;
    constructor(private http: HttpClient) {}

    // New method for paginated admin employee list
    getPagedAdminEmployeeList(filter: any) {
        return this.http
            .post(
                environment.BASE_URL + '/admin/employees/paged',
                filter
            ).pipe(rxjsmap((result: any) => result));
    }

    getBusinessNames(): Observable<any[]> {
      return this.http.get<any[]>(environment.BASE_URL + '/businesses/names');
    }
}
